import { useMutation } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

const sendNotification = async (findReportId: string): Promise<any> => {
	const response = await apiDal.post("/notifications/sendnotificationtocustomer", { findReportId });
	return response.data;
};

/**
 * Send mail to client and update to notified (loser) status.
 * @returns
 */
export const useSendFoundReportMailToClient = () => {
	return useMutation({
		mutationFn: sendNotification,
	});
};
